import { LANGUAGES_ORDER } from '__constants__'

/**
 * Returns the most appropriate translation based on user language and priority fallback.
 *
 * @param {Object} nameObj - Object with language keys (e.g. { EN: '', NO: '...', UK: '...' }).
 * @param {string} language - Current user language (e.g. 'en', 'no', 'uk').
 * @returns {string} - The best matched translation value, or empty string if none found.
 */
const getLocalizedName = (nameObj = {}, language = '') => {
  if (typeof nameObj !== 'object' || !nameObj) return ''

  const normalizedLang = language?.toUpperCase()

  if (nameObj[normalizedLang]?.trim()) {
    return nameObj[normalizedLang].trim()
  }

  for (const lang of LANGUAGES_ORDER) {
    if (nameObj[lang]?.trim()) {
      return nameObj[lang].trim()
    }
  }

  return ''
}

export default getLocalizedName
